/* The Autumn Vault — storefront behaviour.
   Two rules learned the hard way and enforced throughout:
   1. Every element lookup is guarded. This file is one IIFE; a single
      unguarded null aborts everything below it, and the page still LOOKS
      fine — it just silently stops selling.
   2. Prices are never computed here. Liquid emits them; JS only displays. */
(function () {
  'use strict';
  var R = window.AV_ROUTES || {};
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    if (typeof cents !== 'number') return '';
    var fmt = window.AV_MONEY || '${{amount}}';
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* ---- cart API ------------------------------------------------------- */
  var Cart = {
    get: function () { return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); },
    add: function (id, qty) {
      return fetch(R.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart'); return d; }); });
    },
    // /cart/update.js keyed by variant id, not /cart/change.js by line index:
    // line indexes shift under you the moment anything else mutates the cart.
    setQty: function (variantId, qty) {
      var u = {}; u[variantId] = qty;
      return fetch(R.cartUpdate + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: u })
      }).then(function (r) { return r.json(); });
    }
  };

  /* ---- cart count ------------------------------------------------------ */
  function paintCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = !n;
    });
  }

  /* ---- cart drawer ----------------------------------------------------- */
  var drawer = $('#cartDrawer'), scrim = $('#cartScrim'), lastFocus = null;

  function openDrawer() {
    if (!drawer || !scrim) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); scrim.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    var c = $('[data-cart-close]', drawer); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer || !scrim) return;
    drawer.classList.remove('is-open'); scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (scrim) scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cart-open]'); if (o) { e.preventDefault(); openDrawer(); renderCart(); }
    var c = e.target.closest('[data-cart-close]'); if (c) { e.preventDefault(); closeDrawer(); }
  });

  function renderCart() {
    var body = $('#cartLines'), foot = $('#drawerFoot');
    if (!body) return Promise.resolve();
    return Cart.get().then(function (cart) {
      paintCount(cart.item_count);
      var lc = $('#cartLineCount');
      if (lc) lc.textContent = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
      if (!cart.item_count) {
        var empty = document.createElement('li');
        empty.className = 'cartline cartline--empty';
        empty.textContent = 'Your cart is empty.';
        body.replaceChildren(empty);
        if (foot) foot.hidden = true;
        paintSavings(cart);
        paintDeal(cart);
        return;
      }
      if (foot) foot.hidden = false;
      var frag = document.createDocumentFragment();
      cart.items.forEach(function (it) {
        var li = document.createElement('li'); li.className = 'cartline';
        if (it.image) {
          var img = document.createElement('img');
          img.className = 'cartline__img'; img.loading = 'lazy'; img.alt = '';
          img.src = it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
          li.appendChild(img);
        }
        var bodyEl = document.createElement('div'); bodyEl.className = 'cartline__body';
        var nm = document.createElement('a');
        nm.className = 'cartline__name'; nm.href = it.url; nm.textContent = it.product_title;
        bodyEl.appendChild(nm);
        // variant_title is null on single-variant products — never print "null"
        if (it.variant_title) {
          var meta = document.createElement('p');
          meta.className = 'cartline__meta'; meta.textContent = it.variant_title;
          bodyEl.appendChild(meta);
        }
        var ctrl = document.createElement('div'); ctrl.className = 'cartline__ctrl';
        var step = document.createElement('div'); step.className = 'cartline__stepper';
        function mk(label, qty, aria) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'cartline__step';
          b.textContent = label; b.setAttribute('aria-label', aria);
          b.addEventListener('click', function () { bump(it.variant_id, qty); });
          return b;
        }
        var down = mk('−', it.quantity - 1, 'Decrease quantity');
        if (it.quantity === 1) down.classList.add('cartline__step--bin');
        var qty = document.createElement('span');
        qty.className = 'cartline__qty'; qty.textContent = it.quantity;
        step.append(down, qty, mk('+', it.quantity + 1, 'Increase quantity'));
        var rm = document.createElement('button');
        rm.type = 'button'; rm.className = 'cartline__remove'; rm.textContent = 'Remove';
        rm.addEventListener('click', function () { bump(it.variant_id, 0); });
        ctrl.append(step, rm);
        bodyEl.appendChild(ctrl);
        /* final_line_price is after any automatic discount; line_price is not.
           Once the mix-and-match discounts exist the two diverge, and showing
           line_price would print a figure the shopper is not being charged. */
        var pr = document.createElement('div');
        pr.className = 'cartline__price';
        var finalLine = (it.final_line_price != null) ? it.final_line_price : it.line_price;
        var origLine = (it.original_line_price != null) ? it.original_line_price : finalLine;
        pr.textContent = money(finalLine);
        if (origLine > finalLine) {
          var wasEl = document.createElement('s');
          wasEl.className = 'cartline__was'; wasEl.textContent = money(origLine);
          pr.appendChild(wasEl);
        }
        li.append(bodyEl, pr);
        frag.appendChild(li);
      });
      body.replaceChildren(frag);
      var sub = $('#cartSubtotal'); if (sub) sub.textContent = money(cart.total_price);
      paintSavings(cart);
      paintDeal(cart);
    });
  }
  /* ---- mix-and-match deal meter ---------------------------------------
     Counts UNITS across every line, because the Shopify automatic discounts
     behind this apply store-wide: three different designs qualify exactly
     like three of the same one.

     It states the OFFER in words and takes every dollar figure from the cart's
     own total_discount. It never derives a discount itself. */
  function paintSavings(cart) {
    var row = $('#cartSaveRow'), val = $('#cartSave');
    if (!row || !val) return;
    var saved = cart.total_discount || 0;
    if (saved > 0) { row.hidden = false; val.textContent = '−' + money(saved); }
    else { row.hidden = true; val.textContent = ''; }
  }

  function paintDeal(cart) {
    var el = $('#dealMeter');
    if (!el) return;                       // meter switched off in the editor
    var n = cart.item_count || 0, saved = cart.total_discount || 0;
    var msg = $('#dealMsg'), fill = $('#dealFill');
    var m2 = $('#dealMark2'), m3 = $('#dealMark3');
    var text = '', pct = 0;
    if (n === 1) {
      text = el.getAttribute('data-hint-1') || ''; pct = 33;
    } else if (n === 2) {
      pct = 67;
      var h2 = el.getAttribute('data-hint-2') || '';
      text = saved > 0 ? (el.getAttribute('data-applied') || '') + ' — ' + h2 : h2;
    } else if (n >= 3) {
      pct = 100;
      // Only claim a deal is live if the cart actually carries one.
      text = saved > 0 ? (el.getAttribute('data-applied') || '') : '';
    }
    if (!text) { el.hidden = true; return; }
    el.hidden = false;
    if (msg) { msg.textContent = text; msg.classList.toggle('is-done', saved > 0); }
    if (fill) fill.style.width = pct + '%';
    if (m2) m2.classList.toggle('is-hit', n >= 2);
    if (m3) m3.classList.toggle('is-hit', n >= 3);
  }

  function bump(variantId, qty) {
    Cart.setQty(variantId, Math.max(0, qty)).then(renderCart).catch(function () {});
  }

  /* ---- add to cart ----------------------------------------------------- */
  var inFlight = false;
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-addform]');
    if (!form) return;
    e.preventDefault();
    if (inFlight) return;
    var btn = $('[data-addbtn]', form);
    var idEl = $('[name="id"]', form);
    if (!idEl || !idEl.value) return;
    // The set selector writes 1, 2 or 3 into the quantity field. This used to
    // send a hard-coded 1, so picking the Family Set still added one sweatshirt.
    var qtyEl = $('[name="quantity"]', form);
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;
    inFlight = true;
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    Cart.add(idEl.value, qty)
      .then(function () { return renderCart(); })
      .then(function () { openDrawer(); })
      .catch(function (err) {
        var note = $('[data-addnote]', form);
        if (note) { note.textContent = err.message; note.hidden = false; }
      })
      .then(function () {
        inFlight = false;
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
      });
  });
  // bfcache restores this page AND this closure. Without this, pressing Back
  // from checkout leaves every Add-to-cart button permanently dead.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { inFlight = false; $$('[data-addbtn]').forEach(function (b) { b.disabled = false; }); }
  });

  /* ---- variant picker --------------------------------------------------- */
  (function variantPicker() {
    var root = $('[data-product]');
    if (!root) return;                       // not a product page — fine
    var dataEl = $('#productData');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var variants = data.variants || [];
    if (!variants.length) return;

    var form   = $('form[data-addform]', root);
    var idIn   = form ? $('[name="id"]', form) : null;
    var btn    = $('[data-addbtn]', root);
    var nowEl  = $('[data-price-now]', root);
    var wasEl  = $('[data-price-was]', root);
    var offEl  = $('[data-price-off]', root);
    var stock  = $('[data-stock]', root);

    function selected() {
      return $$('[data-optgroup]', root).map(function (g) {
        var c = $('input:checked', g);
        return c ? c.value : null;
      });
    }
    function find(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      })[0] || null;
    }
    // Grey out combinations that do not exist or are sold out, one axis at a
    // time, holding the other axes at their current selection.
    function paintAvailability() {
      var cur = selected();
      $$('[data-optgroup]', root).forEach(function (g, gi) {
        $$('input', g).forEach(function (input) {
          var probe = cur.slice(); probe[gi] = input.value;
          var hit = variants.filter(function (v) {
            return probe.every(function (o, i) { return o === null || v.options[i] === o; });
          });
          var ok = hit.some(function (v) { return v.available; });
          var lab = g.querySelector('label[for="' + input.id + '"]');
          if (lab) lab.classList.toggle('is-un', !ok);
        });
      });
    }
    function apply() {
      var v = find(selected());
      $$('[data-optgroup]', root).forEach(function (g) {
        var c = $('input:checked', g), out = $('[data-optval]', g);
        if (out && c) out.textContent = c.value;
      });
      paintAvailability();
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
        if (stock) { stock.textContent = 'That combination is not available'; stock.classList.add('stock--out'); }
        return;
      }
      if (idIn) idIn.value = v.id;
      if (nowEl) nowEl.textContent = money(v.price);
      if (wasEl) {
        var has = v.compare_at_price && v.compare_at_price > v.price;
        wasEl.hidden = !has;
        wasEl.textContent = has ? money(v.compare_at_price) : '';
        if (offEl) {
          offEl.hidden = !has;
          if (has) offEl.textContent = '−' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        }
      }
      // Rebuild the price slot rather than overwrite it with plain text: the set
      // selector writes the set total into [data-set-price].
      if (btn) {
        btn.disabled = !v.available;
        if (v.available) btn.innerHTML = 'Add to cart &mdash; <span data-set-price>' + money(v.price) + '</span>';
        else btn.textContent = 'Sold out';
      }
      if (stock) {
        stock.classList.toggle('stock--out', !v.available);
        var s = $('[data-stocktext]', stock);
        if (s) s.textContent = v.available ? 'In stock' : 'Sold out';
      }
      if (v.featured_media_index != null) showImage(v.featured_media_index);
      // Colours are priced differently (Red $51.99, Light Pink $46.99), so the
      // set prices must follow the chosen variant, not the first one.
      document.dispatchEvent(new CustomEvent('av:variant', { detail: { price: v.price } }));
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u);
      } catch (err) {}
    }
    $$('[data-optgroup] input', root).forEach(function (i) { i.addEventListener('change', apply); });

    /* gallery */
    var mainImg = $('[data-galmain]', root);
    var thumbs  = $('[data-galthumbs]', root);
    function showImage(i) {
      if (!mainImg || !data.media || !data.media[i]) return;
      mainImg.src = data.media[i].src;
      mainImg.alt = data.media[i].alt || '';
      if (thumbs) $$('button', thumbs).forEach(function (b, bi) { b.setAttribute('aria-current', String(bi === i)); });
    }
    if (thumbs) {
      $$('button', thumbs).forEach(function (b, i) { b.addEventListener('click', function () { showImage(i); }); });
    }
    apply();
  })();

  /* ---- facets: auto-submit --------------------------------------------- */
  (function facets() {
    var form = $('#facetForm');
    if (form) {
      form.addEventListener('change', function () { form.submit(); });
    }
    $$('[data-facet-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var pop = document.getElementById(b.getAttribute('aria-controls'));
        if (!pop) return;
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', String(!open));
        pop.hidden = open;
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.facet')) return;
      $$('[data-facet-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var pop = document.getElementById(b.getAttribute('aria-controls'));
        if (pop) pop.hidden = true;
      });
    });
  })();

  /* ---- mobile nav ------------------------------------------------------- */
  (function nav() {
    var b = $('[data-burger]'), n = $('#siteNav');
    if (!b || !n) return;
    b.addEventListener('click', function () {
      var open = n.classList.toggle('is-open');
      b.setAttribute('aria-expanded', String(open));
    });
  })();

  /* ---- sticky offset ---------------------------------------------------
     .site-head is pinned at top: var(--salebar-h). Nothing sets that variable
     unless we measure the bar, and at 0 the header slides under the sale bar. */
  (function stickyOffset() {
    var bar = $('#saleBar');
    if (!bar) return;
    var set = function () {
      document.documentElement.style.setProperty('--salebar-h', bar.offsetHeight + 'px');
    };
    set();
    window.addEventListener('resize', set);
    if (window.ResizeObserver) new ResizeObserver(set).observe(bar);
  })();

  /* ---- sale bar countdown (off by default) --------------------------- */
  (function saleClock() {
    var bar = $('#saleBar'), clock = $('#saleClock');
    if (!bar || !clock) return;
    var mins = parseInt(bar.getAttribute('data-minutes') || '0', 10);
    if (!mins) return;
    clock.hidden = false;
    var ends = Date.now() + mins * 60000;
    (function tick() {
      var left = ends - Date.now();
      if (left <= 0) { clock.textContent = ''; clock.hidden = true; return; }
      var h = Math.floor(left / 3600000);
      var m = Math.floor(left % 3600000 / 60000);
      var sec = Math.floor(left % 60000 / 1000);
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      // <b> per field: the house sheet boxes each pair of digits
      clock.innerHTML = '<b>' + pad(h) + '</b>:<b>' + pad(m) + '</b>:<b>' + pad(sec) + '</b>';
      setTimeout(tick, 1000);
    })();
  })();

  /* ---- sticky buy bar: appears once the main CTA scrolls away ---------- */
  (function stickyBuy() {
    var bar = $('#stickyBuy'), form = $('#mainAddForm');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { rootMargin: '0px 0px -40px 0px' }).observe(form);
  })();

  /* ---- set selector ----------------------------------------------------
     A set is a QUANTITY of the chosen colour/size. Liquid emits each tier's
     discounted total for the first variant; reprice() redoes the same sum when
     the shopper picks a differently priced colour. The discount itself is
     enforced by Shopify's automatic discounts, not by this page. */
  (function sets() {
    var fs = $('#bundleSelector');
    if (!fs) return;
    var qtyInput = $('[data-qty-input]');
    var int = function (el, a) { return parseInt(el.getAttribute(a), 10) || 0; };
    // Same arithmetic as main-product.liquid, re-run when the variant (and so
    // the unit price) changes. Shopify's automatic discount does the charging;
    // this only has to quote the same figure, to the cent.
    function reprice(unit) {
      $$('input[name="setqty"]', fs).forEach(function (r) {
        var qty = int(r, 'data-set-qty') || 1, pct = int(r, 'data-set-pct');
        var freeN = int(r, 'data-set-free'), halfN = int(r, 'data-set-half');
        var list = unit * qty, now;
        if (pct > 0) {
          now = Math.floor((list * (100 - pct) + 50) / 100);
        } else {
          var fullN = Math.max(0, qty - freeN - halfN);
          now = unit * fullN + (halfN ? Math.floor((unit * halfN + 1) / 2) : 0);
        }
        r.setAttribute('data-set-total', now);
        var card = r.closest('.bundle');
        if (!card) return;
        var p = $('.bundle__price', card); if (p) p.textContent = money(now);
        var w = $('.bundle__was', card); if (w) { w.textContent = money(list); w.hidden = !(now < list); }
        var e = $('[data-set-each]', card); if (e) e.textContent = money(Math.floor(now / qty)) + ' each';
      });
      apply();
    }
    function apply() {
      var sel = $('input[name="setqty"]:checked', fs);
      if (!sel) return;
      if (qtyInput) qtyInput.value = sel.value;
      var total = parseInt(sel.getAttribute('data-set-total'), 10);
      if (!isNaN(total)) {
        $$('[data-set-price]').forEach(function (el) { el.textContent = money(total); });
      }
    }
    $$('input[name="setqty"]', fs).forEach(function (i) { i.addEventListener('change', apply); });
    document.addEventListener('av:variant', function (ev) {
      if (ev.detail && typeof ev.detail.price === 'number') reprice(ev.detail.price);
    });
    apply();
  })();

  renderCart();
})();
